import { Col, Container, Row } from 'reactstrap';
import BlogBoxGrid from './BlogBoxGrid';
import BlogBoxList from './BlogBoxList';
import { LearningListTitle, LearningTitle } from '../../../../constants';
import Breadcrumbs from '../../../../coreComponents/breadcrumbs';
import LearningFilter from '../common/learningFilter';
import { CourseData } from '../../../../types/Tables';
import { Dispatch, SetStateAction, useEffect } from 'react';
import { LearningListContainerProps, LessonProps } from '../../../../types/Courses';

const LearningListContainer = (props: LearningListContainerProps) => {
  if ('courseLessonsData' in props) {
    const lessonProps = props as LessonProps;
    return (
      <Container fluid>
        <Row>
          <Col xl="9" className="xl-60 order-xl-0 order-1 box-col-12">
            <Row>
              <BlogBoxList courseLessonsData={props.courseLessonsData} />
            </Row>
          </Col>
          <LearningFilter
            filters={lessonProps.filters}
            setFilters={lessonProps.setFilters}
            durationFilterSelectors={lessonProps.durationFilterSelectors}
            categoriesFilterSelectors={lessonProps.categoriesFilterSelectors}
            status={lessonProps.status}
          />
        </Row>
      </Container>
    );
  } else {
    return (
      <Container fluid>
        <Row>
          <Col xl="9" className="xl-60 order-xl-0 order-1 box-col-12">
            <Row>
              <BlogBoxGrid coursesData={props.coursesData} />
            </Row>
          </Col>
          <LearningFilter
            filters={props.filters}
            setFilters={props.setFilters}
            durationFilterSelectors={props.durationFilterSelectors}
            status={props.status}
          />
        </Row>
      </Container>
    );
  }
};

export default LearningListContainer;
